import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../Pages/Home/Home";
import AboutPage from "../Pages/About/About";
import CareersPage from "../Pages/Careers/Careers";
import ContactPage from "../Pages/Contacts/Contacts";
import BiometricPage from "../Pages/Products/Biometric";
import EcommercePage from "../Pages/Products/Ecommerce";
import MinibankPage from "../Pages/Products/Minibank";
import OfficeERPPage from "../Pages/Products/Office";
import TravelPage from "../Pages/Products/Travel";
import PosPage from "../Pages/Products/Pos";
import GoldPage from "../Pages/Products/Gold";
import MedicalPage from "../Pages/Products/Medical";
import CustomizedPage from "../Pages/Services/Customized";
import WebdesignPage from "../Pages/Services/Webdesign";
import WebhostPage from "../Pages/Services/Webhost";
import AndroidPage from "../Pages/Services/Android";
import IOSPage from "../Pages/Services/Ios";
import BulksmsPage from "../Pages/Services/Bulksms";
import CRMPage from "../Pages/Services/Crm";
import ERPPage from "../Pages/Services/Erp";
import HRMPage from "../Pages/Services/Hrm";
import TrainingPage from "../TrainingPage/TrainingPage";
import AndroidComponent from "../Training/android";
import AngularComponent from "../Training/angular";
import BigdataComponent from "../Training/Bigdata";
import CorejavaComponent from "../Training/corejava";
import DatascienceComponent from "../Training/datascience";
import DevopsComponent from "../Training/Devops";
import DigitalComponent from "../Training/digital";
import FlutterComponent from "../Training/flutter";
import FullStackComponent from "../Training/fullstack";
import Iostraining from "../Training/Ios";
import MachinelearningComponent from "../Training/machine_learning";
import MeanstackComponent from "../Training/meanstack";
import MernstackComponent from "../Training/mernstack";
import MongodbComponent from "../Training/mongodb";
import NodeJsComponent from "../Training/nodejs";
import PhpComponent from "../Training/php";
import PythonComponent from "../Training/python";
import ReactComponent from "../Training/react";
import ReactnativeComponent from "../Training/Reactnatives";
import SoftwaretestComponent from "../Training/softwaretest";
import WebdesignComponent from "../Training/webdesign";
import Status from "../Status/Status";
import Mail from "../Mail/Mail";
import AllProducts from "../Data/AllProducts";
import SchoolERP from "../Pages/Products/Travel";
import Matrimonial from "../Pages/Products/Matrimonial";
import Webapplication from "../Pages/Services/WebApplication";
import Digitalpage from "../Pages/Services/Digital";
import DataAnalyst from "../Pages/Services/Hrm";
import Seo from "../Pages/Services/Seo";
import YouTube from "../Pages/Services/Youtube&insta";
import CourseDetails from "../TrainingPage/courseDetails";

const MainLink = () => {
  return (
    <Routes>
      {/* navbar link */}
      
      <Route path="/" exact element={<Home />}></Route>
      <Route path="/about-us" exact element={<AboutPage />}></Route>
      <Route path="/products" exact element={<Home />}></Route>
      <Route path="/services" exact element={<Home />}></Route>
      <Route path="/careers" exact element={<CareersPage />}></Route>
      <Route path="/training" exact element={<TrainingPage />}></Route>
      <Route path="/contact-us" exact element={<ContactPage />}></Route>
      <Route path="/school-erp" exact element={<SchoolERP />}></Route>
      <Route path="/matrimonial-website-development" exact element={<Matrimonial />}></Route>



      {/* product drop down link */}

      <Route path="/biometric-attendance" exact element={<BiometricPage />}></Route>
      <Route path="/ecommerce-website-development" exact element={<EcommercePage />}></Route>
      <Route path="/OfficeERPPage" exact element={<OfficeERPPage />}></Route>
      <Route path="/mini-banking-software" exact element={<MinibankPage />}></Route>
      <Route path="/POSPage" exact element={<PosPage />}></Route>
      <Route path="/gold-loan-software" exact element={<GoldPage />}></Route>
      <Route path="/medical-billing-software" exact element={<MedicalPage />}></Route>
      <Route path="/all-products" exact element={<AllProducts />}></Route>

      {/* service dropdown */}
      <Route
        path="/customize-application-development"
        exact
        element={<CustomizedPage />}
      ></Route>
      <Route
        path="/website-design-development"
        exact
        element={<WebdesignPage />}
      ></Route>
      <Route
        path="/web-application-development"
        exact
        element={<Webapplication />}
      ></Route>

      <Route path="/web-hosting-services" exact element={<WebhostPage />}></Route>
      <Route
        path="/android-app-development"
        exact
        element={<AndroidPage />}
      ></Route>
      <Route path="/IOSApplicationPage" exact element={<IOSPage />}></Route>
      <Route path="/bulk-sms-services" exact element={<BulksmsPage />}></Route>
      <Route path="/crm-software" exact element={<CRMPage />}></Route>
      <Route path="/erp-software" exact element={<ERPPage />}></Route>
      <Route path="/data-analytics-services" exact element={<DataAnalyst />}></Route>
      <Route path="/digital-marketing-services" exact element={<Digitalpage />}></Route>
      <Route path="/seo-services" exact element={<Seo />}></Route>
      <Route path="/youtube-instagram-ads" exact element={<YouTube />}></Route>

      {/* Training */}

      {/* <Route path="/status" exact element={<Status />}></Route> */}

      <Route path="/Mail" exact element={<Mail />}></Route>

      <Route path="/training/:slug" element={<CourseDetails />} />


      <Route path="/Android" exact element={<AndroidComponent />}></Route>
      <Route path="/Angular" exact element={<AngularComponent />}></Route>
      <Route path="/Bigdata" exact element={<BigdataComponent />}></Route>
      <Route path="/Corejava" exact element={<CorejavaComponent />}></Route>
      <Route
        path="/Datascience"
        exact
        element={<DatascienceComponent />}
      ></Route>
      <Route path="/Devops" exact element={<DevopsComponent />}></Route>
      <Route path="/Flutter" exact element={<FlutterComponent />}></Route>
      <Route path="/FullStack" exact element={<FullStackComponent />}></Route>
      <Route path="/Iostraining" exact element={<Iostraining />}></Route>
      <Route
        path="/Machinelearning"
        exact
        element={<MachinelearningComponent />}
      ></Route>
      <Route path="/Meanstack" exact element={<MeanstackComponent />}></Route>
      <Route path="/Mernstack" exact element={<MernstackComponent />}></Route>
      <Route path="/Mongodb" exact element={<MongodbComponent />}></Route>
      <Route path="/NodeJs" exact element={<NodeJsComponent />}></Route>
      <Route path="/Php" exact element={<PhpComponent />}></Route>
      <Route path="/Python" exact element={<PythonComponent />}></Route>
      <Route path="/React" exact element={<ReactComponent />}></Route>
      <Route
        path="/Reactnative"
        exact
        element={<ReactnativeComponent />}
      ></Route>
      <Route
        path="/Softwaretest"
        exact
        element={<SoftwaretestComponent />}
      ></Route>
      <Route path="/Webdesign" exact element={<WebdesignComponent />}></Route>
    </Routes>
  );
};
export default MainLink;
